// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  bannerId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ bannerId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/banners/${bannerId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  bannerId: string,
};

export const readComments = ({ bannerId }: ReadCommentsPayload) =>
  axios.get(`/banners/${bannerId}/comments`);

export type ReadSubCommentsPayload = {
  bannerId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ bannerId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/banners/${bannerId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  bannerId: string,
  commentId: string,
};

export const removeComment = ({ bannerId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/banners/${bannerId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  bannerId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ bannerId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/banners/${bannerId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/banners/comments.js